
export default {
  name: "TextComponent",
  props: {
    type: String,
    text: String,
    weight: String,
  },
};
